import { Loader2Icon } from 'lucide-react';

/**
 * Centred loading state for whole-route waits.
 *
 * `role="status"` with the label in the live region means a screen-reader user
 * hears why the page is empty; a bare spinner announces nothing at all.
 */
export function FullPageSpinner({ label = 'Loading' }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      // Prefer filling the parent (auth shell or main) over min-h-svh, which
      // inside the admin layout is taller than the remaining viewport and
      // forces a useless second scroll.
      className="flex min-h-64 w-full flex-1 flex-col items-center justify-center gap-3 py-16"
    >
      <Loader2Icon className="size-6 animate-spin text-muted-foreground" aria-hidden="true" />
      <p className="text-sm text-muted-foreground">{label}…</p>
    </div>
  );
}
